import { Link, Outlet, useLocation } from "@tanstack/react-router";
import { FileInput, Inbox, Send } from "lucide-react";
import { cn } from "@/lib/utils";

const navItems = [
  { label: "Inbox", path: "/general-requirements/inbox", icon: Inbox },
  { label: "Intake", path: "/general-requirements/intake", icon: FileInput },
  { label: "Pending Vista", path: "/general-requirements/pending-vista", icon: Send },
];

export function GeneralRequirementsLayout() {
  const location = useLocation();

  return (
    <div className="flex h-full">
      <nav className="w-48 shrink-0 border-r bg-background pb-6 pt-4">
        <p className="mb-2 px-4 text-xs font-semibold uppercase tracking-wider text-muted-foreground">
          General Requirements
        </p>
        <div className="space-y-0.5 px-2">
          {navItems.map((item) => {
            const active =
              location.pathname === item.path || location.pathname.startsWith(`${item.path}/`);
            return (
              <Link
                key={item.path}
                to={item.path}
                className={cn(
                  "flex items-center gap-2.5 rounded-md px-2 py-1.5 text-sm transition-colors",
                  active
                    ? "bg-accent font-medium text-foreground"
                    : "text-muted-foreground hover:bg-accent hover:text-foreground",
                )}
              >
                <item.icon className="h-4 w-4 shrink-0" />
                {item.label}
              </Link>
            );
          })}
        </div>
      </nav>
      <div className="flex-1 overflow-auto p-6">
        <Outlet />
      </div>
    </div>
  );
}
